import {FieldType} from 'src/openapi/models/FieldType';

export const ConvertorFieldTypeToDataType: Record<FieldType, string> = {
    [FieldType.INTEGER]: 'integer',
    [FieldType.BIG_INTEGER]: 'big Integer',
    [FieldType.DOUBLE]: 'double',
    [FieldType.BOOLEAN]: 'boolean',
    [FieldType.STRING]: 'string',
    [FieldType.DATE_TIME]: 'date time',
    [FieldType.DATE]: 'date',
    [FieldType.ARRAY]: 'array',
    [FieldType.ARRAY_UNIQUE]: 'array unique',
    [FieldType.REFERENCE]: 'reference',
};
